import { CreateGroupEvent } from './create-group/create-group.event';
import { AcceptInviteEvent } from './accept-invite/accept-invite.event';
import { InviteUserEvent } from './invite-user/invite-user.event';
import { todoEvents } from '../todo/events.js';
import { defineEvents } from '@iwentsourcing/core/stream/define-events.js';
import { CreateTodoEvent } from '../todo/create-todo/create-todo.event.js';
import { CompleteTodoEvent } from '../todo/complete-todo/complete-todo.event.js';
import { IncompleteTodoEvent } from '../todo/incomplete-todo/incomplete-todo.event.js';
import { UpdateTodoEvent } from '../todo/update-todo/update-todo.event.js';

export const groupEvents = defineEvents([
  CreateTodoEvent,
  CompleteTodoEvent,
  IncompleteTodoEvent,
  UpdateTodoEvent,
  CreateGroupEvent,
  InviteUserEvent,
  AcceptInviteEvent,
]);

export type GroupEvents = typeof groupEvents;
